interface LoadingScreenProps {
  message: string;
}

export const LoadingScreen = ({ message }: LoadingScreenProps) => {
  return (
    <div className="min-h-screen w-full bg-[#F9FAFC] flex flex-col items-center justify-center px-4">
      <div className="max-w-md text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-genie-primary mb-6 mx-auto"></div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Analyzing Your Conversation</h2>
        <p className="text-lg text-gray-600 mb-6">{message}</p>
        <div className="bg-blue-50 border border-genie-primary rounded-lg p-4">
          <p className="text-base text-genie-primary">
            We're extracting all the details from your conversation to set up your perfect Genie. This will just take a moment...
          </p>
        </div>
      </div>
    </div>
  );
};
